export const getProgressPercentage = (count: number, maxCount: number): number => {
  return Number((count / (maxCount / 100)).toFixed());
};
